module.exports = __webpack_public_path__ + "media/volvo/assets/images/hero_phones@2x-cd57f365c47463ed2714a45801d4e703.png";